import {useContext} from 'react';

import {ValidationContext} from './validation-context';

import type {ValidationContextType, ValidationError} from './validation-context';
import type {ReactElement} from 'react';


type Props = {
    children: (error: string | undefined) => ReactElement,
    name: string,
};
export const CustomValidatedControl = ({name, children}: Props) => {
    const {getErrorsByControlId} = useContext<ValidationContextType>(ValidationContext);

    const error: ValidationError | null = getErrorsByControlId(name).length ? getErrorsByControlId(name)[0] : null;

    return children(error?.message);
};
